var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-screen h-screen lg:p-10 bg-pure-white overflow-hidden" },
    [
      _c("div", { staticClass: "bl-auth-background px-4 lg:p-0" }, [
        _c(
          "div",
          { staticClass: "bl-auth-card rounded-3xl bg-pure-white p-6 lg:p-14" },
          [
            !_vm.sent
              ? _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.verifyEmail($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "space-y-3 mb-6 lg:w-160" },
                      [
                        _c("BlTextTitle4", {
                          attrs: { text: "Forgot your password?" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "Before you can update your password, we need to verify your identity. Please provide your email address below, and we'll send you a link to reset your password."
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlInputText", {
                      staticClass: "mb-4 lg:w-160",
                      attrs: { input: _vm.emailInput },
                      on: { changed: _vm.inputHandler }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-end gap-4" },
                      [
                        _c("BlInputButton", {
                          attrs: { type: "plain", label: "Cancel" },
                          on: { clicked: _vm.goSignin }
                        }),
                        _vm._v(" "),
                        _c("BlInputButton", {
                          attrs: {
                            disabled: !_vm.emailInput.model,
                            buttonType: "submit",
                            label: "Verify",
                            loading: _vm.loading
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.goSignin($event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "space-y-3 mb-6 w-160" },
                      [
                        _c("BlTextTitle4", {
                          attrs: { text: "Check your email" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "We've sent you an email with a link to reset your password. Simply click on the link in the email to continue the password reset process."
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center justify-end gap-4" },
                      [
                        _c("BlInputButton", {
                          attrs: { buttonType: "submit", label: "Got it" }
                        })
                      ],
                      1
                    )
                  ]
                )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10a52436", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10a52436","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/ForgotPassword.vue
// module id = null
// module chunks = 